export const isMobileModeSelector = (state: any) => state.appStatus.isMobileMode || false;